/**
 * Simple Analytics event tracking. Forwards to window.sa_event, provided by
 * the Simple Analytics CDN script loaded in common/js.blade.php. No-ops when
 * the script is absent (blocked, or local without it).
 *
 * Each event carries a per-page-load trigger_count so repeated fires of the
 * same event are distinguishable in the dashboard.
 */
type EventMeta = Record<string, string | number | boolean>;

declare global {
	interface Window {
		sa_event?: (eventName: string, meta?: EventMeta) => void;
	}
}

export class Simple {
	public static triggerCounts: Record<string, number> = {};

	public static event(eventName: string, meta: EventMeta | null = null): void {
		if (!window.sa_event) {
			return;
		}

		if (!Simple.triggerCounts[eventName]) {
			Simple.triggerCounts[eventName] = 0;
		}

		Simple.triggerCounts[eventName]++;

		const payload: EventMeta = { ...(meta ?? {}), trigger_count: Simple.triggerCounts[eventName] };

		window.sa_event(eventName, payload);
	}
}
